import classnames from 'classnames';
import { useSearchParams } from 'react-router-dom';
import { AddIcon, FlashlightIcon } from 'tdesign-icons-react';
import { Button, Tooltip } from 'tdesign-react';

import { DebounceSelect } from '@/components/form/materials/DebounceSelect';
import { Edit4 } from '@/components/icon';
import { ActionType, AssetType, EventType } from '@/const/mission';
import { SEARCH_ID } from '@/const/search';
import { IAssets, IEvents } from '@/interface';
import { CREATE_PROPS_INFO } from '@/router/const';
import { openNewTab } from '@/utils/openNewTab';

import styles from '../index.module.less';

interface IProps {
  contentEventIdColWidth: number | undefined;
  value: IEvents;
  disabled: boolean;
  propsList: { name: string, id: string }[];
  onChange: (value: any) => void;
}

const getId = (value?: IAssets) => value?.id || [];

const PropsItem: React.FC<IProps> = (props) => {
  const { value, onChange, disabled, propsList = [] } = props;

  const [searchParams] = useSearchParams();
  const storyId = searchParams.get(SEARCH_ID) || '';

  const id = getId(value?.action?.showAsset?.itemCard);

  const handleOpen = () => {
    openNewTab(`${CREATE_PROPS_INFO}?storyId=${storyId}`);
  };

  const handleEdit = () => {
    openNewTab(`${CREATE_PROPS_INFO}/${id}?storyId=${storyId}`);
  };

  const propsChange = (_data: number | string, opt: any) => {
    const postData: IEvents = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_SHOWCARD,
        showAsset: {
          type: AssetType.ASSET_TYPE_ITEMSCARD,
          itemCard: opt,
        },
      },
    };
    onChange(postData);
  };

  const fetchList = async () => {
    const list = propsList.map(item => ({
      label: item?.name || '未命名',
      value: item?.id,
      opt: item,
    })).filter(e => e.value);
    return {
      list,
      pageInfo: {
        total: 999,
        current: 1,
        pageSize: 999,
      },
    };
  };

  return (
    <div className={classnames(styles.itemBox, styles.noPadding)}>
      <div className={classnames(styles.system, styles.leftType, 'draggable')}>
        <FlashlightIcon size={14} color="rgb(17, 182, 201)" />
        <span className={styles.label}>道具卡</span>
      </div>
      <div className={styles.contentBox}>
        <DebounceSelect
          fetchOptions={fetchList}
          formData={id}
          hasDefault={true}
          openUpdateOptions={true}
          disabled={disabled}
          placeholder="请选择道具卡"
          empty={
            <div className={styles.smallTips}>
              <div>暂无数据</div>
              <div>请先去新建道具卡</div>
            </div>
          }
          onChange={(val: string | number, opt: any) => propsChange(val, opt)}
        />
        <div className={styles.propsTool}>
          <Tooltip
            content="新建道具卡"
            destroyOnClose
            showArrow
            theme="default"
          >
            <Button
              className={styles.editBtn}
              theme="default"
              onClick={handleOpen}
              disabled={disabled}
            >
              <AddIcon
                className={classnames(
                  { ['nova-disabled']: disabled },
                  { ['nova-disabled-svg']: disabled },
                )}
              />
            </Button>
          </Tooltip>
          <Tooltip
            content="编辑道具卡"
            destroyOnClose
            showArrow
            theme="default"
          >
            <Button
              className={styles.editBtn}
              theme="default"
              onClick={handleEdit}
              disabled={disabled}
            >
              <Edit4
                className={classnames(
                  { ['nova-disabled']: disabled },
                  { ['nova-disabled-svg']: disabled },
                )}
              />
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default PropsItem;
